import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckCircle from '@material-ui/icons/CheckCircleOutline';
import {
  getEndpointChangeAlertAcknowledgeStatus,
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
  updateCanShowShimmer,
} from '../../../../redux_store';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';
import { NULL_QUERY_DELAY } from '../../../Shared/constants';
import showServerError from '../../../../helpers/showError';
import useMetadataUpdate from '../../../../hooks/useMetadataUpdate';
import { useMutation } from 'react-fetching-library';

const RowActions = ({
                      row,
                      setAnchorEl,
                      reloadData,
                    }) => {
  const { en: { titles, notifications, errors } } = useSelector((state) => state.i18n);
  const { metadata: { currentAccount } } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const statusChangeAction = (endpoint, values) => {
    return {
      method: 'POST',
      endpoint: endpoint,
      body: values,
    };
  };

  const { mutate, loading: isStatusLoading } = useMetadataUpdate(useMutation, [statusChangeAction]);

  const onActionClick = async (e, item) => {
    const newEndpoint = getEndpointChangeAlertAcknowledgeStatus(currentAccount.uuid);
    const data = {
      'action': 'acknowledge',
      'alertsUUIDs': [item.uuid],
    };

    const { status, error, payload } = await mutate(newEndpoint, data);

    if (error) {
      switch (status) {
        case 422:
        case 500: {
          if (payload.validationErrors) {
            Object.keys(payload.validationErrors).forEach((key) =>
              showServerError(dispatch, payload.validationErrors[key]),
            );
            break;
          }
          showServerError(dispatch, errors.validationError);
          break;
        }
        default: {
          showServerError(dispatch, errors.unknownError);
          break;
        }
      }
    } else {
      dispatch(updateCanShowShimmer(true));
      reloadData({ delay: NULL_QUERY_DELAY });
      dispatch(
        enqueueSnackbar({
          message: notifications.acknowledgeStatusChanged,
          options: {
            variant: SNACKBAR_VARIANTS.success,
          },
        }),
      );
    }
    setAnchorEl(null);
  };


  return useMemo(
    () => <MenuItem
      title={titles.acknowledge}
      icon={<CheckCircle style={{ fontSize: 16 }} />}
      isLoading={isStatusLoading}
      setAnchorEl={() => {
      }}
      onClick={(e) => onActionClick(e, row.original)}
    />,
    [row, isStatusLoading],
  );
};

export default RowActions;
